export default __webpack_public_path__ + "static/media/microphone.5fd446d3.svg";